// frontend/src/components/Spiral3D.jsx
import React, { forwardRef, useEffect } from "react";
import useSpiralVisualizer from "../hooks/useSpiralVisualizer";

const DYN_ENTROPY_INTERVAL = 150;

const Spiral3D = forwardRef(function Spiral3D(props, ref) {
  const {
    width = 750,
    height = 500,
    onEntropyUpdate,
  } = props;

  const canvasRef = useSpiralVisualizer(props);

  // ✅ expose canvas to parent (SpiralPage)
  React.useImperativeHandle(ref, () => canvasRef.current);

  // 🔹 Gestion entropie dynamique
  useEffect(() => {
    if (!onEntropyUpdate) return;

    let intervalId = null;

    function sendDynEntropySnapshot() {
      const canvas = canvasRef.current;
      if (!canvas || !canvas.__oracleSnapshot) return;

      const snapshot = canvas.__oracleSnapshot();
      fetch("/api/geometry/spiral/dyn_entropy", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(snapshot),
      })
        .then((r) => r.json())
        .then((data) => {
          if (typeof data.entropy === "number") {
            onEntropyUpdate(data.entropy);
          }
        })
        .catch((err) => {
          console.error("Erreur dyn_entropy:", err);
          onEntropyUpdate(null);
        });
    }

    intervalId = setInterval(sendDynEntropySnapshot, DYN_ENTROPY_INTERVAL);

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [onEntropyUpdate]);

  // ✅ Wrapper homogène avec Cubes3D
  return (
    <div
      style={{
        width,
        height,
        position: "relative",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 0 20px rgba(255, 64, 129, 0.3)",
        background: "radial-gradient(circle at center, #0d1117, #000)",
      }}
    >
      <canvas
        ref={canvasRef}
        id="spiral-canvas"
        data-testid="spiral-canvas"
        width={width}
        height={height}
        style={{
          width: "100%",
          height: "100%",
          display: "block",
        }}
      />
    </div>
  );
});

export default Spiral3D;
